import { attachmentService } from "client-app-core";
import { createUserFeedback } from "orion-components/Dock/Actions/index.js";
import { getTranslation } from "orion-components/i18n/Actions/index.js";
import { updateContextProperty } from "orion-components/ContextualData/Actions";

export const attachFilesToCompositeDevice = (id, entityType = "compositeDevice", files) => {
	return dispatch => {
		dispatch(updateContextProperty(id, "uploadError", ""));
		attachmentService.uploadFiles(id, entityType, files, err => {
			if (err) {
				console.error("File upload error:", err);
				dispatch(
					createUserFeedback(
						getTranslation("global.sharedActions.fileUploadFailed", {
							primaryValue: err.message || "An error occurred"
						}),
						null,
						true
					)
				);
				switch (err.response.status) {
					case 413:
						dispatch(
							updateContextProperty(
								id,
								"uploadError",
								getTranslation(
									"global.sharedActions.fileUploadFailed",
									undefined,
									getTranslation("global.sharedActions.uploadError.maxFileSizeExceeded")
								)
							)
						);
						break;
					default:
						dispatch(
							updateContextProperty(
								id,
								"uploadError",
								getTranslation(
									"global.sharedActions.fileUploadFailed",
									undefined,
									getTranslation("global.sharedActions.uploadError.generic")
								)
							)
						);
						break;
				}
				return;
			}
			dispatch(createUserFeedback(getTranslation("global.sharedActions.fileUploadSuccess"), null, false));
		});
	};
};
